<template>
  <div>
    <div class="d-flex align-center filter-box__header pa-3">
      <div class="text-h6 font-weight-black">Filtres</div>
      <v-spacer />
      <v-btn small fab color="error" @click="$emit('cancel')">
        <v-icon>mdi-filter-remove</v-icon>
      </v-btn>
      <v-btn small fab color="success" class="ml-2" @click="$emit('apply')">
        <v-icon>mdi-filter-check</v-icon>
      </v-btn>
    </div>

    <div v-if="isOnlyOneCustomer" class="filter-box__body">
      <v-row>
        <v-col md="6">
          <v-radio-group v-model="vehicleStatus" column>
            <v-radio label="Tous les véhicules" color="primary" value="-1"></v-radio>
            <v-radio label="Vehicules en commande" color="primary" value="0"></v-radio>
            <v-radio label="Véhicules en parc" color="primary" value="1"></v-radio>
            <v-radio label="Véhicules hors parc" color="primary" value="2"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col md="6" class="align-self-center">
          <v-radio-group v-model="leaseStatus" column>
            <v-radio label="Tous les contrats" color="primary" value="0"></v-radio>
            <v-radio label="Contrats en renouvellement" color="primary" value="3"></v-radio>
            <v-radio label="Contrats à renouveller" color="primary" value="1"></v-radio>
            <v-radio label="Contrats echus" color="primary" value="2"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Mise en circulation</v-subheader>
          <v-range-slider
            v-model="yearVehicleRange"
            :min="minYearVehicle"
            :max="maxYearVehicle"
            thumb-label="always"
          />
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Kilométrage annuel</v-subheader>
          <v-range-slider
            v-model="distanceRange"
            min="0"
            max="100000"
            step="1000"
            thumb-label="always"
          />
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Loi de roulage</v-subheader>
          <v-range-slider
            v-model="rollingLawRange"
            min="0"
            max="200"
            step="10"
            thumb-label="always"
          />
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Kilométrage contractuel annuel</v-subheader>
          <v-range-slider
            v-model="leaseDistanceRange"
            min="0"
            max="100000"
            step="1000"
            thumb-label="always"
          />
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Durée du contrat</v-subheader>
          <v-range-slider
            v-model="leaseDurationRange"
            min="0"
            max="72"
            step="12"
            thumb-label="always"
          />
        </v-col>
      </v-row>
    </div>

    <div v-else class="filter-box__body">
      <v-row>
        <v-col md="10" class="align-self-center">
          <div class="d-flex flex-no-wrap">
            <div v-if="imgCustomerLogo">
              <v-avatar tile size="52">
                <v-img :src="imgCustomerLogo" max-width="80" />
              </v-avatar>
            </div>
            <div v-if="!isOnlyOneCustomer" style="width: 100%">
              <v-select
                class="pl-2"
                v-model="customer"
                :items="customers"
                item-text="name"
                item-value="id"
                label="Client"
              ></v-select>
            </div>
          </div>
        </v-col>

        <v-col md="2">
          <v-radio-group v-model="vehicleStatus" column>
            <v-radio label="Tous les véhicules" color="primary" value="-1"></v-radio>
            <v-radio label="Vehicules en commande" color="primary" value="0"></v-radio>
            <v-radio label="Véhicules en parc" color="primary" value="1"></v-radio>
            <v-radio label="Véhicules hors parc" color="primary" value="2"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Mise en circulation</v-subheader>
          <v-range-slider
            v-model="yearVehicleRange"
            :min="minYearVehicle"
            :max="maxYearVehicle"
            thumb-label="always"
          />
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Kilométrage annuel</v-subheader>
          <v-range-slider
            v-model="distanceRange"
            min="0"
            max="100000"
            step="1000"
            thumb-label="always"
          />
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Loi de roulage</v-subheader>
          <v-range-slider
            v-model="rollingLawRange"
            min="0"
            max="200"
            step="10"
            thumb-label="always"
          />
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Kilométrage contractuel annuel</v-subheader>
          <v-range-slider
            v-model="leaseDistanceRange"
            min="0"
            max="100000"
            step="1000"
            thumb-label="always"
          />
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-subheader class="mb-5">Durée du contrat</v-subheader>
          <v-range-slider
            v-model="leaseDurationRange"
            min="0"
            max="72"
            step="12"
            thumb-label="always"
          />
        </v-col>

        <v-col md="2" class="align-self-center">
          <v-radio-group v-model="leaseStatus" column>
            <v-radio label="Tous les contrats" color="primary" value="0"></v-radio>
            <v-radio label="Contrats en renouvellement" color="primary" value="3"></v-radio>
            <v-radio label="Contrats à renouveller" color="primary" value="1"></v-radio>
            <v-radio label="Contrats echus" color="primary" value="2"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "AVehicleFilterBox",
  props: {
    userFilters: {
      type: Object,
      required: true
    },
    customers: {
      type: Array,
      required: true
    },
    isOnlyOneCustomer: {
      type: Boolean,
      required: true
    },
    imgCustomerLogo: {
      type: String,
      default: undefined
    },
    minYearVehicle: {
      type: Number,
      required: true
    },
    maxYearVehicle: {
      type: Number,
      required: true
    }
  },
  computed: {
    customer: {
      get() {
        return this.userFilters.customer
      },
      set(value) {
        this.updateUserFilters({ customer: value })
      }
    },
    yearVehicleRange: {
      get() {
        return this.userFilters.yearVehicleRange
      },
      set(value) {
        this.updateUserFilters({ yearVehicleRange: value })
      }
    },
    distanceRange: {
      get() {
        return this.userFilters.distanceRange
      },
      set(value) {
        this.updateUserFilters({ distanceRange: value })
      }
    },
    leaseDistanceRange: {
      get() {
        return this.userFilters.leaseDistanceRange
      },
      set(value) {
        this.updateUserFilters({ leaseDistanceRange: value })
      }
    },
    leaseDurationRange: {
      get() {
        return this.userFilters.leaseDurationRange
      },
      set(value) {
        this.updateUserFilters({ leaseDurationRange: value })
      }
    },
    leaseStatus: {
      get() {
        return this.userFilters.leaseStatus
      },
      set(value) {
        this.updateUserFilters({ leaseStatus: value })
      }
    },
    vehicleStatus: {
      get() {
        return this.userFilters.vehicleStatus
      },
      set(value) {
        this.updateUserFilters({ vehicleStatus: value })
      }
    },
    rollingLawRange: {
      get() {
        return this.userFilters.rollingLawRange
      },
      set(value) {
        this.updateUserFilters({ rollingLawRange: value })
      }
    }
  },
  methods: {
    updateUserFilters(patch) {
      this.$emit('update:userFilters', { ...this.userFilters, ...patch })
    }
  }
}
</script>
